import React, { useEffect, useRef, useState } from 'react';
import { getWheelConfig } from '@base/activity/CouponDrawWheel/services'
import { IDrawResultCoupon, IWheelConfigData, ResultType } from '@base/activity/CouponDrawWheel/interface'
import styles from './index.module.less';
import RewardModal from '@base/activity/CouponDrawWheel/RewardModal';
import WheelDrawModal, { IWheelDrawModalRef } from '@base/activity/CouponDrawWheel/WheelDrawModal';
import Image from '@base/lib/ThemeImage';
import { observer, useStore } from 'base/store';
import {
    COOKIE_COUPON_WHEEL_MINI_ENTRANCE_HIDE,
    COOKIE_COUPON_WHEEL_MODAL_DISPLAYED,
    COOKIE_COUPON_WHEEL_RESULT_UNIQUE_ID
} from '@base/activity/CouponDrawWheel/constant';
import { delCookie, getCookie, setCookie } from 'ava-util/dist/cookie';
import Message from '@base/lib/Message';
import cn from 'classnames';
import { FixedItem, IStatus, PopupsItem, StateType } from 'base/store/popupFixedStore';
import { useTrans } from 'base/utils/i18n';
import Iconfont from '@base/lib/Iconfont'

type IProps = {
    // props
}

const CouponDrawWheel: React.FC<IProps> = observer((props) => {

    const [wheelConfig, setWheelConfig] = useState<IWheelConfigData>()
    const [rewardVisible, setRewardVisible] = useState<boolean>(false);
    const [wheelVisible, setWheelVisible] = useState<boolean>(false)
    const [result, setResult] = useState<IDrawResultCoupon>();
    const [showMiniEntry, setShowMiniEntry] = useState<boolean>(false);

    const { userStore, popupFixedStore } = useStore();
    const isLogin = userStore.checkAuth();

    const { t } = useTrans();

    const canvasModalRef = useRef<IWheelDrawModalRef>(null);

    const popupStoreHandle = (state: IStatus) => {
        popupFixedStore.changeState(StateType.Popup, PopupsItem.couponWheelPopup, state);
        popupFixedStore.changeState(StateType.Fixed, FixedItem.couponWheelFixed, state);
    }

    const getWheelConfigHandle = async () => {
        try {
            popupStoreHandle('loading');
            const configRes = await getWheelConfig();
            
            if (!configRes) {
                popupStoreHandle('false')
                return
            }

            setWheelConfig(configRes)

            const eachDayDisplayed = getCookie(COOKIE_COUPON_WHEEL_MODAL_DISPLAYED)
            const notLoginResultId = getCookie(COOKIE_COUPON_WHEEL_RESULT_UNIQUE_ID)

            const userResult = configRes?.drawResultCoupon

            if (isLogin && notLoginResultId && !!userResult) {
                // 未登录时已抽过
                if (userResult?.uniqueId === notLoginResultId) {
                    setRewardVisible(true)
                } else {
                    // Message.error('Oops! You’ve already claimed this coupon.')
                    Message.error(t('web_spin_already_claimed'))
                }

                delCookie(COOKIE_COUPON_WHEEL_RESULT_UNIQUE_ID)
                popupFixedStore.changeState(StateType.Popup, PopupsItem.couponWheelPopup, 'true');

            } else if (!eachDayDisplayed && configRes.canDraw) {
                // 记录每天访问一次
                if (!getCookie(COOKIE_COUPON_WHEEL_MODAL_DISPLAYED)) {
                    setCookie(COOKIE_COUPON_WHEEL_MODAL_DISPLAYED, 'true', 1)
                }

                popupFixedStore.changeState(StateType.Popup, PopupsItem.couponWheelPopup, 'true');
                setWheelVisible(true);

            } else {
                popupFixedStore.changeState(StateType.Popup, PopupsItem.couponWheelPopup, 'false');

            }

        } catch (err) {
            Message.error(err.message)
            popupStoreHandle('false');

        } finally {

        }
    }

    const currentTime = Math.floor(Date.now() / 1000);
    const isInActivity = (wheelConfig?.startTime || 0) < currentTime
        && currentTime < (wheelConfig?.endTime || 0);

    const showCouponIcon = wheelConfig?.drawResultCoupon?.type === ResultType.COUPON

    const showEntryHandle = () => {
        const showWheelFixed = isInActivity
            && !getCookie(COOKIE_COUPON_WHEEL_MINI_ENTRANCE_HIDE)
            && !!(!!wheelConfig && (
                wheelConfig.canDraw ||
                wheelConfig.drawResultCoupon ||
                wheelConfig.canObtainCoupon
            ))

        popupFixedStore.changeState(StateType.Fixed, FixedItem.couponWheelFixed, showWheelFixed ? 'true' : 'false');
        const showStoreWheelFixed = popupFixedStore.checkDisPlayInOrder(StateType.Fixed, FixedItem.couponWheelFixed)

        setShowMiniEntry(showStoreWheelFixed && showWheelFixed)
    }

    const handleClose = () => {
        setCookie(COOKIE_COUPON_WHEEL_MINI_ENTRANCE_HIDE, '1', 1)
        showEntryHandle()
    };


    useEffect(() => {
        showEntryHandle()
    }, [wheelConfig]);

    useEffect(() => {
        getWheelConfigHandle().then()

    }, [isLogin]);

    return !isInActivity ? null : (
        <div className={styles['coupon-wheel-wrap']}>

            <RewardModal
                wheelConfig={wheelConfig}
                visible={rewardVisible}
                onClose={() => {
                    // canvasModalRef.current?.hiddenChange()
                    setRewardVisible(false)
                }}
                result={result}
            />

            <WheelDrawModal
                ref={canvasModalRef}
                onClose={() => setWheelVisible(false)}
                visible={wheelVisible}
                wheelConfig={wheelConfig}
                onEndDrawWheel={(result,) => {
                    setResult(result);
                    if (result?.type === ResultType.COUPON) {
                        // 打开coupon结果弹窗
                        setRewardVisible(true);
                        setWheelVisible(false)
                    }
                    if (result?.type !== ResultType.ONE_TIME_AGAIN) {
                        // 重新获取配置
                        getWheelConfigHandle().then()
                    }
                }}
            />

            {(showMiniEntry) && (
                <div
                    className={cn(styles['fixed-entrance'], "flex flex-center flex-middle pointer")}

                >
                    <Image
                        onClick={() => {
                            if (showCouponIcon) {
                                setRewardVisible(true)

                            } else {
                                setWheelVisible(true)

                            }
                        }}
                        src={showCouponIcon
                            ? (wheelConfig?.couponIcon?.link || 'asset/width-300/picture/5fced22e363942d4cf54fc87e7606c02.png')
                            : (wheelConfig?.spinIcon?.link || 'asset/width-326/picture/6b87b7710a0d726311273612348aab35.png')
                        }
                        width={'100%'}
                        fixed
                        fit={'contain'}
                        background={false}
                    />

                    <button
                        className={cn(styles['btn-close'], 'btn-no-style')}
                        onClick={handleClose}
                    >
                        <Iconfont className="icon-x"/>
                    </button>
                </div>

            )}

        </div>
    );
});

export default CouponDrawWheel